import React, { useState } from 'react';
import { Field } from 'redux-form';
import Icon from '../../../../common/components/Icon/Icon';
import TextArea from '../../../content/components/TextArea';
import Button from '../../../../common/components/Button/Button';
import ReactMarkdown from 'react-markdown';
import './CollapsedField.scss';

const DeclarationText = ({ input }) => {
  return (<div className={'collapsed-field--readonly RichEditor-editor'}>
    {input.value ? (
      <ReactMarkdown source={input.value}/>
    ) : (
      <div>no content found. Click to add content.</div>
    )}
  </div>
  );
};

const Fields = ({
  show,
  name,
  isLoading,
  onSave
}) => {

  const [isEditingEnabled, setIsEditingEnabled] = useState(false);

  if (!show) {
    return null;
  }

  const handleEditDefinition = () => {
    setIsEditingEnabled(true);
  };
  const handleCancelEditing = () => {
    setIsEditingEnabled(false);
  };

  const handleSaveChanges = () => {
    setIsEditingEnabled(false);
    onSave();
  };

  return (
    <>
    <div

      className="animated fadeIn hoverable-text"
      onClick={handleEditDefinition}
    >
       <div className="animated fadeIn">
          <Field
            name={name}
            component={isEditingEnabled ? TextArea: DeclarationText}
          />
        </div>

    </div>
      {isEditingEnabled && (
        <div>
          <Button bsStyle="default" handleClick={handleCancelEditing}>
            Cancel
          </Button>
          <Button
            bsStyle="primary"
            className="pull-right"
            isLoading={isLoading}
            handleClick={handleSaveChanges}
          >
            Save Changes
          </Button>
        </div>
      )}
      </>
  );


};
const CollapsedField = ({
  input,
  label,
  isLoading,
  onSave
}) => {
  const [showField, setShowField] = useState(false);
  const toggleShowField = () => {
    setShowField(!showField);
  };

  return (
    <div className={'collapsed-field '}>
      <div
        className={`collapsed-field--title ${showField ? 'red-title' : 'blue-title'}`}
        onClick={toggleShowField}
      >
        {label}
        <Icon name={showField ? 'minus-circle' : 'plus-circle'}/>
      </div>


      <Fields
          show={showField}
          name={input.name}
          isLoading={isLoading}
          onSave={onSave}
        />


    </div>
  );
};

export default CollapsedField;
